import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ReviewDetail } from "../../model/v2/review/review-detail";
import { ReviewSummary } from "../../model/v2/review/review-summary";
import { EmployerProfileResponse } from "../../models/employer/employer-profile-response";
import { EmployerRegistration } from "../../models/employer/employer-registration";
import { EmployerRegistrationRequest } from "../../models/employer/employer-registration-request";
import { PagedResult } from "../../models/PageRequestInterface";
import { ResultBase } from "../../models/result-base";
import { BaseService } from "../shared/base.service";
import { EmployeeSubscription, EMPSubscriptionCheckout, GetEmployerSubscription, GetEMPSubscriptionCheckout, PatientSubscription } from "../../models/patient/patientFavoriteRequest";

@Injectable({
  providedIn: 'root'
})
export class EmployerService {

  constructor(private baseService: BaseService) { }
  AddEmployerRegistrationRequest(
    empRegistrationData: EmployerRegistration
  ): Observable<any> {
    return this.baseService.anonymousPost<any>(
      `Employer/AddEmployerRegistration`,
      empRegistrationData
    );
  }
  GetAllPendingRegistrations(
    pageIndex: number,
    pageSize: number,
    activeStatus: number
  ): Observable<PagedResult<EmployerRegistration>> {
    return this.baseService.get<PagedResult<EmployerRegistration>>(
      `Employer/GetEmployerRegistrationData?pageIndex=${pageIndex}&pageSize=${pageSize}&activeStatus=${activeStatus}`
    );
  }
  GetAllActiveInActiveRegistrations(
    pageIndex: number,
    pageSize: number,
    activeStatus: number
  ): Observable<PagedResult<EmployerRegistration>> {
    return this.baseService.get<PagedResult<EmployerRegistration>>(
      `Employer/GetEmployerData?pageIndex=${pageIndex}&pageSize=${pageSize}&activeStatus=${activeStatus}`
    );
  }


  updateEmployerRegistrationData(
    hoDto: EmployerRegistrationRequest
  ): Observable<any> {
    return this.baseService.patch<any>(
      `Employer/UpdateEmployerRegistrationData`,
      hoDto
    );

  }
  addEmployer(
    hoDto: EmployerRegistrationRequest
  ): Observable<any> {
    return this.baseService.post<any>(
      `Employer/AddEmployer`,
      hoDto
    );

  }

  DeactiveEmployer(einNumber: string): any {
    return this.baseService.post<any>(
      `Employer/DeactiveEmployer?einNumber=${einNumber}`,
      {}
    );
  }
  getEmployerProfileDetails(id: number): Observable<EmployerProfileResponse> {
    return this.baseService.get<EmployerProfileResponse>(
      `Employer/GetEmployerDataById?Id=${id}`
    );
  }
  getEmployerDataByName(
    pageIndex: number,
    pageSize: number,
    searchString:string,
    activeStatus: number
  ): Observable<PagedResult<EmployerRegistration>> {
    return this.baseService.get<PagedResult<EmployerRegistration>>(
      `Employer/GetEmployerDataByName?pageIndex=${pageIndex}&pageSize=${pageSize}&searchString=${searchString}&activeStatus=${activeStatus}`
    );
  }
  updatemployerProfileDetails(data: FormData): Observable<any> {
    return this.baseService.upload<any>(`Employer/UpdateEmployerProfile`, data);
  }
  deleteEmployerLocation(employerLocationId: string): Observable<any> {
    return this.baseService.delete<any>(`Employer/DeleteEmployerLocation?id=` + employerLocationId);
  }
  uploadEmployeeData(data: FormData): Observable<any> {
    return this.baseService.upload<any>('Employer/UploadEmployeeData', data);
  }
  // bulkUploadEmployeeData(data: FormData, employerId: number): Observable<any> {
  //   return this.baseService.fileUpload<any>('MemberRawData/UploadMemberRawData',data);
  // }
  // bulkUploadEmployeeData(data: FormData, employerId: number): Observable<any> {
  //   return this.baseService.fileUpload<any>(
  //     `MemberRawData/UploadMemberRawData?employerId=${employerId}`,
  //     data
  //   );
  // }
  bulkUploadEmployeeData(data: FormData): Observable<any> {
    const url = `MemberRawData/UploadMemberRawData`;
    return this.baseService.fileUpload<any>(url, data); // Pass FormData and URL with employerId
  }
  pdfEmployerFileUploadData(data: FormData): Observable<any> {
    const url = `Employer/uploadEmployerPdf`;
    return this.baseService.fileUpload<any>(url, data); // Pass FormData and URL with employerId
  }
  

  // updateEmployerHealthSubscription(patientOrgId:number,employerOrgId:number,subscriptionType:number,activationType: string,employeeIds: number[]):Observable<any>{
  //   const employerSubscription: PatientSubscription = {
  //     patientId: patientOrgId,
  //     employerId:employerOrgId,
  //     employeeIds: employeeIds,
  //     subscriptionTypeId: subscriptionType,
  //     activationType: activationType,
  //   };
  //   return this.baseService.post<any>('Employer/UpdateEmployerHealthSubscription', employerSubscription);
  // }
  updateEmployerHealthSubscription(employerOrgId:number,subscriptionType:number,activationType: string):Observable<any>{
    const employerSubscription: EmployeeSubscription = {
      employerId:employerOrgId,
      subscriptionTypeId: subscriptionType,
      activationType: activationType,
    };
    return this.baseService.post<any>('Employer/UpdateEmployerHealthSubscription', employerSubscription);
  }
  getEmployerHealthSubscription(employerId: GetEmployerSubscription): Observable<any> {
    return this.baseService.get<any>(`Employer/GetEmployerHealthSubscription?employerId=${employerId}`);
}
getEmployerSubscriptionCheckOutInfomation(employergId:number):Observable<any>{
  const empSubscriptionCheckout: GetEMPSubscriptionCheckout = { 
    employerId:employergId,
  };
  return this.baseService.post<any>('Employer/GetEmployerSubscriptionCheckOutInformation', empSubscriptionCheckout);
}
// getEmployerSubscriptionCheckOutInfomation(employergId:number):Observable<any>{
//   const empSubscriptionCheckout: EMPSubscriptionCheckout = {

//     employerId:employergId,

//   };
//   return this.baseService.post<any>('Employer/GetEmployerSubscriptionCheckOutInformation', empSubscriptionCheckout);
// }
// updateEmployeeHealthSubscription(employerOrgId:number,activationType: string):Observable<any>{
//   const employerSubscription: EmployeeSubscription = {
//     employerId:employerOrgId,
//     activationType: activationType,
//   };
//   return this.baseService.post<any>('Employer/UpdateEmployeeHealthSubscription', employerSubscription);
// }
updateEmployeeHealthSubscription(employerOrgId:number,subscriptionType:number,activationType: string):Observable<any>{
  const employerSubscription: EmployeeSubscription = {
    employerId:employerOrgId,
    subscriptionTypeId: subscriptionType,
    activationType: activationType,
  };
  return this.baseService.post<any>('Employer/UpdateEmployeeHealthSubscription', employerSubscription);
}
}
